import ReactDOM from 'react-dom/client';
import './ress.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './constants/translations';

import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

import { AuthProvider } from './contexts/Auth';
import { MainProvider } from './contexts/Main';
import { RequestProvider } from './contexts/Request';

import 'react-tooltip/dist/react-tooltip.css';
import DnDProvider from './components/DnD/DnDProvider';
import { ENV, DEFAULT_LANGUAGE, GTM_ID } from './constants';

import FallbackError from './components/common/FallbackError';
import { SignProvider } from './contexts/Sign';

import offscreenCanvasPolyfill from '../src/utils/offscreenCanvasPolyfill';
import replaceAllPolyfill from '../src/utils/replaceAllPolyfill';
import arrayAtPolyfill from './utils/arrayAtPolyfill';
import { init } from './init';

offscreenCanvasPolyfill();
replaceAllPolyfill();
arrayAtPolyfill();

init();

if (ENV === 'PROD') {
    TagManager.initialize({
        gtmId: GTM_ID,
    });
}

if (ENV === 'PROD') {
    Sentry.init({
        dsn: 'https://a2d538520e4e8cb1b8bb985e4eda5c6c@o4510495246188544.ingest.de.sentry.io/4510495247302736',
        environment: ENV,
    });
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: translations,
        lng: DEFAULT_LANGUAGE, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    // <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackError />}>
        <BrowserRouter>
            <AuthProvider>
                <RequestProvider>
                    <MainProvider>
                        <SignProvider>
                            <DnDProvider>
                                <App />
                            </DnDProvider>
                        </SignProvider>
                    </MainProvider>
                </RequestProvider>
            </AuthProvider>
        </BrowserRouter>
    </Sentry.ErrorBoundary>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
